import { Classes, Tag } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import { Description } from "@/components/pieces/coaching/coach-profile/CoachingProducts/Description";
import { MIDTEXT_COLOR } from "@/css/constants";
import { ProductDetailQuery } from "@/graphql";

type Product = ProductDetailQuery["productById"]["product"];
interface ProductInformationProps {
  product: Product;
  loading: boolean;
}

export function ProductInformation({
  product,
  loading,
}: ProductInformationProps) {
  const { name, description, specialty } = product || {};
  const loadingCssClass = loading ? Classes.SKELETON : "";

  return (
    <Flex justifyContent="space-between">
      <Box>
        <Box fontWeight={600} mb={2} className={loadingCssClass}>
          <Tag intent="primary">{specialty?.name}</Tag>
        </Box>
        <Box fontWeight={600} fontSize={24} className={loadingCssClass}>
          {name}
        </Box>
        <Box
          css={{
            opacity: 0.8,
          }}
          className={loadingCssClass}
        >
          <Description color={MIDTEXT_COLOR} text={description || ""} />
        </Box>
      </Box>
    </Flex>
  );
}
